import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button, Select } from 'antd';
import { useHistory } from 'react-router-dom';
import { changeWorkSpace } from '../../store/routines/workspaceRoutines';
import { USER_TYPES } from '../../common/constants/UserManagementConstants';

function SelectWorkspaceForm() {
  const history = useHistory();
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const isValidSession = useSelector((state) => state.auth.isValidSession);
  const workSpaces = useSelector((state) => state.workSpace.workSpaces);
  const isLoading = useSelector((state) => state.workSpace.isLoading);
  const errorMessage = useSelector((state) => state.workSpace.errorMessage);
  const isError = useSelector((state) => state.workSpace.isError);

  const defaultWorkSpace = workSpaces.find(
    (workSpace) => workSpace.userType === USER_TYPES.TENANT
  );
  useEffect(() => {
    if (!isValidSession) {
      history.replace('/login');
    }
  }, [isValidSession, history]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        // Check if the focus is not on the select input
        if (document.activeElement.tagName !== 'INPUT') {
          event.preventDefault();
          formRef.current.submit();
        }
      }
    };

    // Add event listener
    window.addEventListener('keypress', handleKeyPress);

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('keypress', handleKeyPress);
    };
  }, []);

  const onFinish = (values) => {
    const { workspace } = values;
    const selectedWorkspace = workSpaces.find(
      (workSpace) => workSpace.tenantId === workspace
    );
    dispatch(changeWorkSpace({ workSpace: selectedWorkspace, reload: false }));
  };

  return (
    <>
      <div className="login-input-wrapper">
        <div className="title no-bottom-margin">Select Workspace</div>
        <div className="subtitle center">
          Select the workspace you want to enter
        </div>
        <Form
          name="work_space_select"
          className="login-form"
          layout="vertical"
          initialValues={{ workspace: defaultWorkSpace?.tenantId }}
          onFinish={onFinish}
          ref={formRef}
        >
          {isError && (
            <div className="login-error-bar">
              <i className="icon core-icon core-alert-outlined" />{' '}
              {errorMessage}
            </div>
          )}
          <Form.Item
            label=""
            name="workspace"
            className="input login-field workspace"
          >
            <Select
              className="login-field"
              placeholder="Select a workspace"
              defaultActiveFirstOption
            >
              {workSpaces.map((tenant) => (
                <Select.Option key={tenant.tenantId} value={tenant.tenantId}>
                  {tenant.tenantName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button loginbtn"
              loading={isLoading}
            >
              Enter
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="filler"> </div>
    </>
  );
}

export default SelectWorkspaceForm;
